<dl>
  <ng-container *ngIf="showFieldKeys">
    <ng-container *ngFor="let controlName of getControlNames()">
      <dt
        *ngIf="
          showFieldName &&
          (getMessagesForField(controlName).length > 0 ||
            getFieldErrors(controlName).length > 0)
        "
      >
        {{ controlName }}
      </dt>
      <ng-container *ngIf="getFieldErrors(controlName).length > 0">
        <dd>
          <ul>
            <li
              *ngFor="let message of getFieldErrors(controlName)"
              class="error-message"
            >
              {{ message }}
            </li>
          </ul>
        </dd>
      </ng-container>
      <ng-container *ngIf="getMessagesForField(controlName).length > 0">
        <dd>
          <ul>
            <li
              *ngFor="let message of getMessagesForField(controlName)"
              class="error-message"
            >
              {{ message }}
            </li>
          </ul>
        </dd>
      </ng-container>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="showNonFieldKeys">
    <ng-container *ngFor="let key of getNonFieldKeys()">
      <dt *ngIf="showFieldName">{{ key }}</dt>
      <dd>
        <ul>
          <li
            *ngFor="let message of getMessagesForField(key)"
            class="error-message"
          >
            {{ message }}
          </li>
        </ul>
      </dd>
    </ng-container>
  </ng-container>
</dl>
